const user = [{
    path: 'cases',
    name: 'cases',
    meta: {
      pubView: true
    },
    component: () =>
      import( /* webpackChunkName: "cases" */ '../views/user/cases.vue')
  },{
    path: 'connections',
    name: 'connections',
    meta: {
      pubView: true
    },
    component: () =>
      import( /* webpackChunkName: "connections" */ '../views/user/connections.vue')
  },{
    path: 'instituations',
    name: 'instituations',
    meta: {
      pubView: true
    },
    component: () =>
      import( /* webpackChunkName: "instituations" */ '../views/user/instituations.vue')
  },{
    path: 'members',
    name: 'members',
    meta: {
      pubView: true
    },
    component: () =>
      import( /* webpackChunkName: "members" */ '../views/user/members.vue')
  },{
    path: 'models',
    name: 'models',
    meta: {
      pubView: true
    },
    component: () =>
      import( /* webpackChunkName: "models" */ '../views/user/models.vue')
  },{
    path: 'users',
    name: 'users',
    meta: {
      pubView: true
    },
    component: () =>
      import( /* webpackChunkName: "users" */ '../views/user/users.vue')
  },{
    path: 'roles',
    name: 'roles',
    meta: {
      pubView: true
    },
    component: () =>
      import( /* webpackChunkName: "roles" */ '../views/user/roles.vue')
  },{
    path: 'products',
    name: 'products',
    meta: {
      pubView: true
    },
    component: () =>
      import( /* webpackChunkName: "products" */ '../views/user/products.vue')
  },{
    path: 'configurations',
    name: 'configurations',
    meta: {
      pubView: true
    },
    component: () =>
      import( /* webpackChunkName: "configurations" */ '../views/user/configurations.vue')
  },{
    path: 'devices',
    name: 'devices',
    meta: {
      pubView: true
    },
    component: () =>
      import( /* webpackChunkName: "devices" */ '../views/user/devices.vue')
  }
];
export default user;